import React, { Component, lazy, Suspense } from 'react';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';
import SettingsPage from '../Pages/SettingsPage';
import VariantOptionRoutes from './VariantOptionRoutes';
import MeasurementUnitRoutes from './MeasurementUnitRoutes';
import KitchenDisplayRoutes from './KitchenDisplayRoutes';
import BillPostingSettingsRoutes from './BillPostingSettingsRoutes';

import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

function SettingsRoute() {
    const history = useHistory();
    return (
        <Switch>
            {/* Variant Options Routes */}
            <Route
                path="/:lng/settings/variant-options"
                render={(props) => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <VariantOptionRoutes {...props} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            
            {/* Measurement Units Routes */}
            <Route
                path="/:lng/settings/measurement-units"
                render={(props) => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <MeasurementUnitRoutes {...props} />
                        </Suspense>
                    </React.Fragment>
                )}
            />

            {/* Kitchen Display Routes */}
            <Route
                path="/:lng/settings/kitchen-displays"
                render={(props) => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <KitchenDisplayRoutes {...props} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            {/* Bill Posting Settings Routes */}
            <Route
                path="/:lng/settings/bill-posting-settings"
                render={(props) => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <BillPostingSettingsRoutes {...props} />
                        </Suspense>
                    </React.Fragment>
                )}
            />

            {/* Main Settings Page Route - Keep this last as it's a catch-all */}
            <Route
                exact
                path="/:lng/settings/:type?/:next_step?"
                render={(props) => (
                    <React.Fragment>
                        <SettingsPage history={history} {...props} />
                    </React.Fragment>
                )}
            />

           
        </Switch>
    );
}

export default SettingsRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
